export default __webpack_public_path__ + "static/media/DSC05910.283531e1.jpg";